import TextFieldComponent from '@/Inputs/TextFieldComponent';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { getCustomerRefferal, getGNumberIdentifier } from '@/services/Redux/Reducer/CustomerSlice';
import { useDispatch } from 'react-redux';
import localStorageCall from '@/services/Methods/localstorage.hook';
import { useEffect } from 'react';
import useDebounce from '../../../../hooks/useDebounce';
import { storeAssigned } from '@/services/Methods/normalMethods';

function CheckoutStepTwo({ REFFERAL_LINK, isUserLogin, handleChangeFunction, selectedLanguage, setSelectedLanguage, ...props }) {
    const fieldValue = useFormikContext();
    const [showPassword, setShowPassword] = useState(false);
    const formDataKeys = { webAliase: '', emailAddresse: '', customerId: '' }
    const [formData, setFormData] = useState(formDataKeys);
    const [referralSearchData, setRefferalSearchData] = useState({ data: '' });
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [refselectedData, setRefSelectedData] = useState();
    const [isLoadings, setIsLoadings] = useState(false);
    const [isLoadingGNumber, setIsLoadingGNumber] = useState(false);
    const [EnrollerError, setEnrollerError] = useState(false);
    const [displayReferral, setDisplayReferrer] = useState(false);

    const [searchCriteria, setSearchCriteria] = useState('webAliase'); // Track selected dropdown value
    const dispatch = useDispatch();

    const handleChangeFunctions = (e, currentPage = 1) => {
        if (e) e.preventDefault();
        const newValue = e.target.value;
        setFormData((prevData) => {
            const updatedData = { ...prevData, [searchCriteria]: newValue };
            return updatedData;
        });
    };
    const handleSearchReferral = () => {
        setDropdownOpen(true);
        setRefferalSearchData({ data: '' });
        setEnrollerError(false)
        const VALUES = _.compact(_.values(formData)).map(value => value.trim());

        if (VALUES.length > 0) {
            setIsLoadings(true);
            dispatch(getCustomerRefferal((data, totalRecords) => {
                if (data?.length > 0 && _.find(data, ({ customerId }) => !_.includes([1, 2, 3, 4, 5], customerId))) {
                    setRefferalSearchData({ data: data });
                    setEnrollerError(false);
                } else {
                    setRefferalSearchData({ data: '' });
                    setEnrollerError(true);
                }
                setIsLoadings(false);
            }, formData, 'normal'));
        }
    }

    const selectedData = (referralId, referralName, webAliasName) => {
        fieldValue?.setFieldValue(`webAliase`, referralName);
        setDropdownOpen(false);
        setRefSelectedData(referralName);
        setDisplayReferrer(true);
        const refferalData = JSON.stringify({ "id": referralId, "name": referralName, "webalies": webAliasName });
        localStorage.setItem('referralID', referralId);
        localStorageCall().removeItem('TreeMoveData');
        localStorageCall().setItem('refferal_link', refferalData);
    };

    const handleSearchCriteriaChange = (e) => {
        setSearchCriteria(e.target.value);
        setEnrollerError(false);
        setFormData(formDataKeys)
    };

    useEffect(() => {
        const REFFERAL_VALUES = localStorageCall().getItem('refferal_link');
        if (REFFERAL_VALUES) {
            setDisplayReferrer(true);
            setRefSelectedData(REFFERAL_VALUES?.name);
            fieldValue?.setFieldValue(`webAliase`, REFFERAL_VALUES?.name);
            setFormData((prevData) => ({
                ...prevData,
                [searchCriteria]: REFFERAL_VALUES?.webalies,
            }));
        }
    }, []);

    const debouncedGNumber = useDebounce(fieldValue?.values?.gNumber, 2000);
    useEffect(() => {
        if (debouncedGNumber) {
            setIsLoadingGNumber(true);
            dispatch(getGNumberIdentifier(debouncedGNumber, () => setIsLoadingGNumber(false)));
        }
    }, [debouncedGNumber]);

    return (
        <section>
            {!isUserLogin && <div className='flex flex-wrap gap-0 md:gap-4 search_class'>
                <div className="relative w-full sm:w-[calc(100%/2-8px)] text-[#444444a6]">
                    <select
                        value={searchCriteria}
                        onChange={handleSearchCriteriaChange}
                        className="w-full border px-4 py-2 mb-4"
                    >
                        {/* <option value="firstName">Search Enroller With First Name</option>
                        <option value="lastName">Search Enroller With Last Name</option> */}
                        <option value="webAliase">Search Enroller With Web Alias</option>
                        <option value="customerId">Search Enroller With ID</option>
                        <option value="emailAddresse">Search Enroller With Email</option>
                    </select>

                    {/* {searchCriteria === 'firstName' && ( */}
                    <div className='relative'>
                        <TextFieldComponent
                            name={searchCriteria}
                            type="text"
                            label="Search Enroller"
                            value={formData[searchCriteria]}
                            onChange={handleChangeFunctions}
                            onBlur={(e) => {
                                fieldValue?.handleBlur(e);
                                handleChangeFunctions(e, fieldValue?.values);
                            }}
                            errorMessage={(referralSearchData?.data?.length > 0 || !EnrollerError) ? fieldValue?.errors?.webAliase || "" : "No Result Found"}
                            divClass={'w-full pr-0'}
                        />


                        {isLoadings && (
                            <div className="absolute top-[20%] right-[4%]">
                                <img width="20" src="/images/loading-new.gif" alt="Loading" />
                            </div>
                        )}
                        {dropdownOpen && referralSearchData?.data?.length > 0 && (
                            <div className="dropdown-container">
                                {referralSearchData?.data?.map((referralData) => (
                                    <div
                                        key={referralData?.enrollerId}
                                        className="display-result"
                                        onClick={() => { console.log('onclick is working fine'), selectedData(referralData?.customerId, referralData?.publicProfile?.fullName !== " " ? referralData?.publicProfile?.fullName : referralData?.fullName, referralData?.webAlias) }}
                                    >
                                        {referralData?.publicProfile?.fullName !== " " ? referralData?.publicProfile?.fullName : referralData?.fullName}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {displayReferral && (
                    <p className='text-[#000] text-[18px] asla_cst'>Referred by: {refselectedData}</p>
                )}
                <button
                    type="button"
                    onClick={handleSearchReferral}
                    disabled={formData[searchCriteria]?.length < 1}
                    className={`search_btn_main flex items-center px-4 py-2 rounded-lg  hover:no-underline ${formData[searchCriteria]?.length < 1 ? 'bg-gray-400 text-white hover:bg-gray-400' : 'bg-black text-white hover:bg-gray-800'}`}
                >
                    Search
                </button>
            </div>}
            {(props?.SINGLE_MEMBERSHIPCHECK && _.upperCase(storeAssigned()) === 'JP') && <div className='flex flex-wrap gap-4 relative'>
                <TextFieldComponent
                    name="gNumber"
                    type='text'
                    label="Gaiyoshomen Number"
                    value={fieldValue?.values?.gNumber}
                    onChange={fieldValue?.handleChange}
                    onBlur={(e) => {
                        fieldValue?.handleBlur(e);
                        handleChangeFunction(e, fieldValue?.values);
                    }}
                    errorMessage={fieldValue?.errors?.gNumber || props?.gNumberErrorMsg}
                    divClass={"sm:w-[calc(100%/2-8px)] w-full"}
                />
                {isLoadingGNumber && (
                    <div className="absolute top-[20%] right-[4%]">
                        <img width="20" src="/images/loading-new.gif" alt="Loading" />
                    </div>
                )}
            </div>}
            {!isUserLogin && <div className='flex flex-wrap gap-4'>
                <TextFieldComponent
                    name="shipping_email"
                    type='text'
                    disabled={!!isUserLogin}
                    label="Email"
                    value={fieldValue?.values?.shipping_email}
                    onChange={fieldValue?.handleChange}
                    onBlur={(e) => {
                        fieldValue?.handleBlur(e);
                        handleChangeFunction(e, fieldValue?.values)
                    }}
                    errorMessage={fieldValue?.errors?.shipping_email}
                    divClass={'sm:w-full w-full'}
                />
            </div>}
            {(!isUserLogin) && (
                <div className='flex flex-wrap gap-4'>
                    <TextFieldComponent
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        label="Password"
                        value={fieldValue?.values?.password}
                        onChange={fieldValue?.handleChange}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            handleChangeFunction(e, fieldValue?.values)
                        }}
                        errorMessage={fieldValue?.errors?.password}
                        divClass={"sw-full pr-0"}
                        onEyeClick={() => setShowPassword(!showPassword)}
                        showPass={showPassword}
                    />

                    <TextFieldComponent
                        name="confirm_password"
                        type='password'
                        label="Confirm Password"
                        value={fieldValue?.values?.confirm_password}
                        onChange={fieldValue?.handleChange}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            handleChangeFunction(e, fieldValue?.values)
                        }}
                        errorMessage={fieldValue?.errors?.confirm_password}
                        divClass={"sm:w-[calc(100%/2-8px)] w-full"}
                        onEyeClick={() => setShowPassword(!showPassword)}
                        showPass={showPassword}
                    />
                </div>
            )}
        </section>
    );
}
export default CheckoutStepTwo;